import { Column, Entity, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ConversationAnalyzerEntity } from './conversation-analyzer.entity';

export enum CriterionType {
	BOOLEAN = 'boolean',
	SCALE = 'scale',
	OUTCOME = 'outcome',
}

export interface OutcomeMapping {
	outcome: string;
	points: number;
}

@Entity('_conversation_analyzer_criterion')
export class ConversationAnalyzerCriterionEntity extends BaseEntity {
	@Column({
		name: 'fk__conversation_analyzer__id',
		type: 'int',
		unsigned: true,
	})
	public analyzerId!: number;

	@ManyToOne(() => ConversationAnalyzerEntity, (a) => a.criteria, {
		onDelete: 'CASCADE',
		onUpdate: 'CASCADE',
	})
	@JoinColumn({ name: 'fk__conversation_analyzer__id' })
	public analyzer!: ConversationAnalyzerEntity;

	@Column({ name: 'name', type: 'varchar', length: 150, nullable: false })
	public name!: string;

	@Column({ name: 'description', type: 'text', nullable: true })
	public description?: string;

	@Column({ name: 'evaluation_prompt', type: 'text', nullable: false })
	public evaluationPrompt!: string;

	@Column({
		name: 'criterion_type',
		type: 'enum',
		enum: CriterionType,
	})
	public criterionType!: CriterionType;

	@Column({
		name: 'weight',
		type: 'decimal',
		precision: 5,
		scale: 2,
		default: 1.0,
	})
	public weight!: number;

	@Column({ name: 'max_points', type: 'int', default: 10 })
	public maxPoints!: number;

	@Column({ name: 'sort_order', type: 'int', default: 0 })
	public sortOrder!: number;

	@Column({ name: 'scale_min', type: 'int', nullable: true, default: 1 })
	public scaleMin?: number;

	@Column({ name: 'scale_max', type: 'int', nullable: true, default: 5 })
	public scaleMax?: number;

	@Column({ name: 'outcome_mappings', type: 'json', nullable: true })
	public outcomeMappings?: Array<OutcomeMapping>;

	@Column({ name: 'is_required', type: 'tinyint', width: 1, default: 0 })
	public isRequired!: boolean;

	@Column({ name: 'category', type: 'varchar', length: 50, nullable: true })
	public category?: string;
}
